













































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';
import { SfAccordion } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import PdfProductUrl from '~/modules/pdfDownload/components/Link/ProductUrl.vue';
import { getProductAssembly } from '~/modules/catalog/product/getters/productGetters';
import SvgImage from '~/components/General/SvgImage.vue';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  components: {
    SfAccordion,
    PdfProductUrl,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    tab: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { lastOpenedTabId, resetLastOpenedTabId } = toRefs(useProductStore());

    return {
      lastOpenedTabId,
      resetLastOpenedTabId,
      getProductAssembly,
    };
  },
});
